<template>

  <div class="month-view">
    <table class="month-table">
      <thead>
        <tr>
          <!-- Заголовки дней недели -->
          <th v-for="(label, idx) in weekdays" :key="idx">{{ label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(week, wIdx) in weeks" :key="wIdx">
          <td
            v-for="(dayDate, dIdx) in week"
            :key="dayDate.getTime()"
            :class="[
              'day-cell',
              {
                'other-month': dayDate.getMonth() !== currentDate.getMonth(),
                'today': formatDate(dayDate) === todayStr && formatDate(dayDate) !== selectedStr,
                'selected': formatDate(dayDate) === selectedStr
              }
            ]"
            @dragover.prevent
            @drop="onDrop($event, dayDate)"
          >
            <div class="cell-content">
              <div class="day-number">{{ dayDate.getDate() }}</div>
              <!-- Иконка для выбора дня (без перехода в режим "день") -->
              <span class="day-icon" @click.stop="selectDay(dayDate)">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" viewBox="0 0 64 64" style="enable-background:new 0 0 512 512" xml:space="preserve">
                  <g>
                    <g fill="#000">
                      <path fill-rule="evenodd" d="M42 2v10a8 8 0 0 0 8 8h11.977c.015.201.023.404.023.607V46c0 8.837-7.163 16-16 16H18C9.163 62 2 54.837 2 46V18C2 9.163 9.163 2 18 2zm1 30a2 2 0 0 1-2 2h-7v7a2 2 0 1 1-4 0v-7h-7a2 2 0 1 1 0-4h7v-7a2 2 0 1 1 4 0v7h7a2 2 0 0 1 2 2z" clip-rule="evenodd" fill="#dddddd" opacity="1"></path>
                      <path d="M46 2.742V12a4 4 0 0 0 4 4h10.54a7.995 7.995 0 0 0-1.081-1.241L48.093 4.152A7.998 7.998 0 0 0 46 2.742z" fill="#dddddd" opacity="1"></path>
                    </g>
                  </g>
                </svg>
              </span>
            </div>
            <!-- Список задач для данного дня -->
            <ul class="tasks-list">
              
              <li
                v-for="task in getCurDate(tasks, dayDate)"
                :key="task.id"
                class="task-item"
              >
              <div>
                <div class="time_hour">{{ getTimeTaks(task.dueDate) }}</div>
                <div class="time_title">{{ task.taskText }}</div>
              </div>

              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "MonthViewForTasks",
  props: {
    // currentDate – выбранная дата (selected)
    currentDate: { type: Date, required: true },
    tasks: { type: Array, default: () => [] }
  },
  computed: {
    weekdays() {
      return ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];
    },
    weeks() {
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();
      const firstOfMonth = new Date(year, month, 1);
      let dayOfWeek = firstOfMonth.getDay();
      if (dayOfWeek === 0) dayOfWeek = 7;
      const emptyBefore = dayOfWeek - 1;
      const lastOfMonth = new Date(year, month + 1, 0);
      const totalDays = lastOfMonth.getDate();
      const days = [];
      // Даты из предыдущего месяца
      for (let i = 0; i < emptyBefore; i++) {
        days.push(new Date(year, month, 1 - (emptyBefore - i)));
      }
      // Даты текущего месяца
      for (let d = 1; d <= totalDays; d++) {
        days.push(new Date(year, month, d));
      }
      // Дополняем до 42 ячеек датами из следующего месяца
      while (days.length < 42) {
        days.push(new Date(year, month, totalDays + (days.length - totalDays) + 1));
      }
      const weeks = [];
      for (let i = 0; i < 6; i++) {
        weeks.push(days.slice(i * 7, i * 7 + 7));
      }
      return weeks;
    },
    // todayStr – сегодняшняя дата (форматированная)
    todayStr() {
      return this.formatDate(new Date());
    },
    // selectedStr – выбранная дата (форматированная, из prop currentDate)
    selectedStr() {
      return this.formatDate(this.currentDate);
    }
  },
  methods: {
    getCurDate(tasks,dayDate) {
      const todayStr = this.formatDate(dayDate);
      console.log(tasks);
      return tasks.filter(task => {
        const taskDate = task.dueDate.split(' ')[0]; // Получаем только дату без времени
        return taskDate === todayStr; // Сравниваем с текущей датой
      });
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
      const year = date.getFullYear();
      return `${day}.${month}.${year}`; // Форматируем как "дд.мм.гггг"
    },
    getTimeTaks(dueDate) {
      // Здесь можно реализовать форматирование времени, если нужно
      return dueDate.split(' ')[1]; // Возвращаем только время
    },
    
    dayClick(dayDate) {
      this.$emit("dayClick", dayDate);
    },
    selectDay(dayDate) {
      this.$emit("daySelect", dayDate);
    },
    taskClick(task) {
      this.$emit("taskClick", task);
    },
    tasksForDay(dayDate) {
      // Фильтруем задачи для данного дня по формату даты "ГГГГ-ММ-ДД"
      const dayStr = this.formatDate(dayDate);
      console.log('daystr' + dayStr);
      let tasksForDay = this.tasks.filter(task => {
        return task.dueDate === dayStr;
      });
      console.log(tasksForDay);
      // Сортируем задачи по времени (поле start_hour представлено числом)
      tasksForDay.sort((a, b) => a.start_hour - b.start_hour);
      return tasksForDay;
    },

    // Обработка начала перетаскивания задачи
    onDragStart(event, task) {
      event.dataTransfer.setData("text/plain", String(task.id));
      event.dataTransfer.effectAllowed = "move";
    },
    // При drop задачи рассчитываем новое время: newStartTime = 7 + (количество задач в этот день) * 0.5
    onDrop(event, dayDate) {
      const count = this.tasksForDay(dayDate).length;
      const newStartTime = 7 + count * 0.5;
      const taskId = event.dataTransfer.getData("text/plain");
      if (taskId) {
        this.$emit("taskDropped", { taskId, newDate: dayDate, newStartTime });
      }
    }
  }
};
</script>

<style scoped>
.month-table {
  width: 100%;
  border-collapse: collapse;
}
.month-table th {
  text-align: center;
  padding: 6px;
  background: #f0f0f0;
  border: 1px solid #ddd;
}
.day-cell {
  vertical-align: top;
  width: calc(100% / 7);
  height: 100px;
  border: 1px solid #ddd;
  position: relative;
  cursor: pointer;
  padding: 4px;
  background: #fff;
}

.time_hour {
  margin-bottom: 2px;
    font-size: 10px;
    font-weight: 4;
    color: rgb(0 0 0 / 59%);
}

.other-month {
 background: #f4f6f8;
    color: #aaa;
    opacity: 0;
}
/* Если дата ячейки равна сегодня (todayStr) и не выбрана – жёлтый фон */
.day-cell.today {
  background-color: rgb(255 239 191);
}
/* Если дата ячейки равна выбранной (selectedStr) – зелёный фон */
.day-cell.selected {
  background-color: rgba(188, 232, 241, 0.3);
}
.cell-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.day-number {
  font-weight: bold;
}
.day-icon {
  font-size: 16px;
  cursor: pointer;
}
.tasks-list {
  list-style: none;
  padding: 0;
  margin: 4px 0 0 0;
  font-size: 12px;
}
.task-item {
    background: transparent;
    color: #000;
    margin: 2px 0;
    padding: 2px 0px;
    border-radius: 0px;
    cursor: move;
    line-height: 12px;
    border-bottom: dashed 1px rgb(0 0 0 / 8%);
    padding-bottom: 5px;
}

.task-item:last-child {
   border-bottom: solid 0px rgb(0 0 0 / 8%);
}

.time_title {
  font-weight: 800;
}

.day-icon svg {
  width: 20px;
    height: 20px;
}

.day-cell.selected path{
  fill: #357abd;

}

.day-cell.today path{
  fill: #fea530;
}



</style>
